(function () {
  var toggle = document.querySelector('.nav-toggle');
  var menu = document.getElementById('nav-mobile-menu');
  var nav = document.querySelector('.nav');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      menu.hidden = isOpen;
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (toggle.getAttribute('aria-expanded') !== 'true') return;
      toggle.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
      toggle.focus();
    });
  }

  if (nav) {
    window.addEventListener(
      'scroll',
      function () {
        if (window.scrollY > 8) {
          nav.classList.add('nav--scrolled');
        } else {
          nav.classList.remove('nav--scrolled');
        }
      },
      { passive: true }
    );
  }
})();
